import { Link } from 'react-router-dom'
import { Mail, ArrowRight } from 'lucide-react'
import { Logo } from '@/features/marketing/components/Logo'

/**
 * Recuperar contraseña — diseño portado 1:1 desde el landing.
 * Pantalla informativa por ahora (sin backend); se conecta al reintegrar el SSO.
 */
export function ResetPasswordPage() {
  return (
    <div className="min-h-screen bg-neutral-50 grid place-items-center px-5 relative">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(40%_40%_at_50%_20%,rgba(217,96,46,0.12),transparent_70%)]" />
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <Link to="/" className="inline-flex"><Logo /></Link>
        </div>
        <div className="bg-white/80 backdrop-blur-xl border border-black/5 p-6 lg:p-8 rounded-3xl shadow-sm">
          <h1 className="text-2xl font-bold tracking-tight">Recuperar contraseña</h1>
          <p className="text-muted-foreground text-sm mt-2 mb-6">
            Ingresa tu correo y te enviaremos un enlace para restablecerla.
          </p>
          <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
            <label className="block">
              <span className="text-xs font-semibold text-muted-foreground">Correo</span>
              <div className="mt-1.5 flex items-center gap-2 px-3.5 py-3 rounded-xl border border-black/10 bg-white focus-within:border-primary">
                <Mail className="size-4 text-muted-foreground" />
                <input type="email" required placeholder="tu@negocio.com" className="flex-1 bg-transparent outline-none text-sm" />
              </div>
            </label>
            <button type="submit" className="w-full py-3.5 bg-foreground text-background font-semibold rounded-xl hover:bg-primary transition-colors inline-flex items-center justify-center gap-2">
              Enviar enlace <ArrowRight className="size-4" />
            </button>
          </form>
          <Link to="/login" className="block text-center text-sm text-muted-foreground mt-6 hover:text-foreground">
            ← Volver a iniciar sesión
          </Link>
        </div>
      </div>
    </div>
  )
}
